/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogCancel,
  AlertDialogTitle,
  AlertDialogAction,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FileUpload } from '@/components/sendEvent/FileUpload';
import { Send } from 'lucide-react';
import { useState } from 'react';
import { serviceUploadNewNiche } from '@/services/upload';
import { useApp } from '@/context/AppContext';

export function AddNiche() {
  const { callApis } = useApp();
  const [open, setOpen] = useState(false);
  const [newType, setNewType] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClear = () => {
    setOpen(false);
    setNewType('');
    setFile(null);
  };

  const handleAddType = async () => {
    setLoading(true);
    if (!newType.trim() || !file) return;

    try {
      await serviceUploadNewNiche({
        name: newType,
        file,
      });
      await callApis();
      setNewType('');
      setFile(null);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
    }
  };

  const disabled = !newType.trim() || !file;

  return (
    <AlertDialog
      open={open}
      onOpenChange={(e) => {
        if (!e) handleClear();
        setOpen(e);
      }}
    >
      <AlertDialogTrigger asChild>
        <Button variant="outline" onClick={() => setOpen(true)}>
          + Adicionar Novo Nicho
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle style={{ textAlign: 'center' }}>Adicionar Nicho</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="flex flex-col flex-1 gap-2 items-center ">
          <Label htmlFor="userName"></Label>
          <Input
            className="justify-center max-w-[410px]"
            id="newType"
            placeholder="Insira o nome do nicho"
            value={newType}
            onChange={(e) => setNewType(e.target.value)}
          />
          <FileUpload selectedFile={file} onFileSelect={setFile} />
        </div>
        <AlertDialogFooter style={{ justifyContent: 'center' }}>
          <AlertDialogCancel onClick={handleClear}>Cancelar</AlertDialogCancel>
          {loading ? (
            <AlertDialogAction disabled={true} onClick={handleAddType}>
              Adicionando...
            </AlertDialogAction>
          ) : (
            <AlertDialogAction disabled={disabled} onClick={handleAddType}>
              <Send className="mr-2 h-4 w-4" />
              Adicionar Nicho
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
